import styled from 'styled-components'

export const HiddenCrawlableNavigationContent = styled.div`
  display: none;
`
